import React, { useState } from "react";
import "./gallery.css";
import GalleryLightbox from "./GalleryLightbox";

import {
  useGetPublicGalleryImagesQuery,
  useGetGalleryCategoriesQuery,
  useGetGalleryEventsQuery,
} from "../../features/gallery/galleryApiSlice";

const Index = () => {

  const [page, setPage] = useState(1);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // ============================
  // FETCH IMAGES
  // ============================

  const {
    data,
    isLoading,
    isFetching,
  } = useGetPublicGalleryImagesQuery({
    page,
    limit: 12,
    event: selectedEvent,
    category: selectedCategory,
    year: selectedYear,
  });

  const images = data?.data || [];
  const hasMore = data?.hasMore;

  // ============================
  // FETCH FILTER DATA
  // ============================

  const { data: categoriesData } = useGetGalleryCategoriesQuery();
  const { data: eventsData } = useGetGalleryEventsQuery();

  const categories = categoriesData?.data || [];
  const events = eventsData?.data || [];

  // ============================
  // LIGHTBOX
  // ============================

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  // ============================
  // LOAD MORE
  // ============================

  const loadMore = () => {

    if (!isFetching && hasMore) {
      setPage(prev => prev + 1);
    }

  };

  // ============================
  // FILTER HANDLERS
  // ============================

  const handleEventChange = (e) => {
    setSelectedEvent(e.target.value);
    setPage(1);
  };

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
    setPage(1);
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
    setPage(1);
  };

  // ============================
  // YEAR LIST (2005 → current)
  // ============================

  const currentYear = new Date().getFullYear();
  const years = [];

  for (let y = currentYear; y >= 2005; y--) {
    years.push(y);
  }

  return (

    <div className="inner-wrapper">

      <div className="gallery-container">

        <h2 className="gallery-title">
          Spiritual Gallery
        </h2>

        {/* FILTERS */}

        <div className="gallery-filters">

          {/* YEAR */}

          <select value={selectedYear} onChange={handleYearChange}>
            <option value="">All Years</option>

            {years.map(year => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}

          </select>


          {/* EVENT */}

          <select value={selectedEvent} onChange={handleEventChange}>
            <option value="">All Events</option>

            {events.map(event => (
              <option key={event._id} value={event.slug}>
                {event.title}
              </option>
            ))}

          </select>


          {/* CATEGORY */}

          <select value={selectedCategory} onChange={handleCategoryChange}>
            <option value="">All Categories</option>

            {categories.map(cat => (
              <option key={cat._id} value={cat.slug}>
                {cat.title}
              </option>
            ))}

          </select>

        </div>


        {/* GRID */}

        <div className="gallery-grid">

          {images.map((img, index) => (

            <div
              key={img._id}
              className="gallery-card"
              onClick={() => openLightbox(index)}
            >

              <img
                src={img.image.url}
                alt=""
                loading="lazy"
              />

            </div>

          ))}

        </div>


        {/* EMPTY STATE */}

        {!isLoading && images.length === 0 && (
          <p className="gallery-empty">
            No images found
          </p>
        )}


        {/* LOAD MORE */}

        {hasMore && (

          <div className="gallery-load-more">

            <button onClick={loadMore}>
              {isFetching ? "Loading..." : "Load More"}
            </button>

          </div>

        )}

        {isLoading && (
          <p className="gallery-loading">
            Loading gallery...
          </p>
        )}

      </div>


      {/* LIGHTBOX */}

      {lightboxOpen && (

        <GalleryLightbox
          images={images}
          index={currentIndex}
          onClose={() => setLightboxOpen(false)}
          onNext={nextImage}
          onPrev={prevImage}
        />

      )}

    </div>

  );

};

export default Index;